/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationConfigViewModel
 */
export interface ApplicationConfigViewModel {
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigViewModel
     */
    buildNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigViewModel
     */
    releaseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationConfigViewModel
     */
    environment?: string | null;
}

/**
 * Check if a given object implements the ApplicationConfigViewModel interface.
 */
export function instanceOfApplicationConfigViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationConfigViewModelFromJSON(json: any): ApplicationConfigViewModel {
    return ApplicationConfigViewModelFromJSONTyped(json, false);
}

export function ApplicationConfigViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationConfigViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'buildNumber': !exists(json, 'buildNumber') ? undefined : json['buildNumber'],
        'releaseNumber': !exists(json, 'releaseNumber') ? undefined : json['releaseNumber'],
        'environment': !exists(json, 'environment') ? undefined : json['environment'],
    };
}

export function ApplicationConfigViewModelToJSON(value?: ApplicationConfigViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'buildNumber': value.buildNumber,
        'releaseNumber': value.releaseNumber,
        'environment': value.environment,
    };
}

